export default __webpack_public_path__ + "static/media/gif pulcinella.6bc3e132.gif";